export const articleType = {
  STORY: 'Story',
  NEWS: 'News',
  EVENT: 'Event'
};
